module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DateChooseYear"
  }, [_vm._v("时间选择：\n  "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "el-date-shortcut__item",
      on: {
        "click": function($event) {
          _vm.handleItemClickYear(index)
        }
      }
    }, [_c('a', {
      class: {
        'el-date-shortcut__a': true, active: index === _vm.active
      },
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5790950","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/DateShortCut/DateChooseYear.vue
// module id = 847
// module chunks = 11